import React, { useState } from 'react';
import { supabase } from '../../utils/supabase';
import { AuthFormProps } from './types';
import './styles.scss';

const ForgotPasswordForm: React.FC<AuthFormProps> = ({ setAuthView }) => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Without redirectTo the link lands on the Supabase Site URL and the
      // app never sees the recovery token.
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/`,
      });
      if (error) throw error;
      setSuccess(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="success-screen">
        <div className="success-icon">✓</div>
        <h2>Email Sent!</h2>
        <p>Check your inbox for password reset instructions.</p>
        <button onClick={() => setAuthView('login')} className="btn btn-primary">
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <h2>Reset Password</h2>
      <p className="auth-subtitle">We'll send you a reset link</p>

      {error && <div className="error-message">{error}</div>}

      <div className="form-content">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="form-input"
          required
        />
        <button onClick={handleSubmit} disabled={loading} className="btn btn-primary btn-large">
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
        <button onClick={() => setAuthView('login')} className="btn btn-secondary">
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
